import React from "react";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { whyChoose } from "../../mock/mock";
import Reveal from "../common/Reveal";

const Card = ({ item, index }) => (
  <div className="group relative h-full snap-start min-w-[78%] sm:min-w-[55%] md:min-w-0 bg-white rounded-2xl border border-black/5 p-7 overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_22px_60px_rgba(0,0,0,0.10)]">
    {/* growing accent bar */}
    <span
      className="absolute left-0 top-0 h-1 w-0 group-hover:w-full transition-all duration-500"
      style={{ background: "var(--tnf-blue)" }}
    />
    {/* index watermark */}
    <span className="absolute -top-3 right-4 font-display text-[70px] font-extrabold text-black/[0.04] leading-none select-none">
      {index + 1}
    </span>

    <div className="relative flex items-start justify-between">
      <div
        className="w-14 h-14 rounded-2xl flex items-center justify-center overflow-hidden transition-all duration-300 group-hover:scale-110"
        style={{ background: "rgba(5,165,213,0.10)" }}
      >
        <img src={item.icon} alt="" className="w-9 h-9 object-contain" />
      </div>
      <span
        className="w-8 h-8 rounded-full flex items-center justify-center opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
        style={{ background: "var(--tnf-blue)" }}
      >
        <ArrowUpRight size={15} color="#fff" />
      </span>
    </div>

    <h4 className="relative font-display text-[18px] font-bold text-[#0e0e10] mt-5">
      {item.title}
    </h4>
    <p className="relative text-[14px] leading-relaxed text-[#3b3b3b]/80 mt-2">
      {item.text}
    </p>
  </div>
);

const WhyChooseUs = () => {
  return (
    <section className="py-20 lg:py-28">
      <div className="tnf-container">
        <Reveal className="max-w-2xl mb-10 md:mb-12">
          <span className="tnf-eyebrow">Why Talk N' Fix</span>
          <h2 className="font-display text-[32px] sm:text-[42px] font-extrabold text-[#0e0e10] mt-3 leading-[1.08]">
            Why Choose Talk N' Fix?
          </h2>
          <p className="text-[#3b3b3b]/80 text-[16px] mt-3">
            The 6 reasons Freehold chooses our 5-star, same-day service.
          </p>
        </Reveal>

        {/* Mobile swipe hint */}
        <div className="flex md:hidden items-center gap-2 mb-4 text-[13px] font-medium text-[#3b3b3b]/70">
          <span>Swipe to explore</span>
          <ArrowRight size={16} className="tnf-nudge" style={{ color: "var(--tnf-blue)" }} />
        </div>

        <Reveal className="flex md:grid md:grid-cols-2 lg:grid-cols-3 gap-5 overflow-x-auto md:overflow-visible snap-x-mandatory md:snap-none tnf-scroll-blue pt-3 pb-9 md:pt-0 md:pb-0 -mt-3 -mb-5 md:my-0 -mx-6 px-6 md:mx-0 md:px-0">
          {whyChoose.map((item, i) => (
            <Card key={i} item={item} index={i} />
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default WhyChooseUs;
